/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GroupWithTeams } from './GroupWithTeams';
import {
    GroupWithTeamsFromJSON,
    GroupWithTeamsFromJSONTyped,
    GroupWithTeamsToJSON,
    GroupWithTeamsToJSONTyped,
} from './GroupWithTeams';
import type { StageType } from './StageType';
import {
    StageTypeFromJSON,
    StageTypeFromJSONTyped,
    StageTypeToJSON,
    StageTypeToJSONTyped,
} from './StageType';

/**
 * 
 * @export
 * @interface StageWithGroups
 */
export interface StageWithGroups {
    /**
     * 
     * @type {string}
     * @memberof StageWithGroups
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof StageWithGroups
     */
    name?: string;
    /**
     * 
     * @type {StageType}
     * @memberof StageWithGroups
     */
    stageType?: StageType;
    /**
     * 
     * @type {number}
     * @memberof StageWithGroups
     */
    orderIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof StageWithGroups
     */
    bracket?: string;
    /**
     * 
     * @type {Array<GroupWithTeams>}
     * @memberof StageWithGroups
     */
    groups?: Array<GroupWithTeams>;
}



/**
 * Check if a given object implements the StageWithGroups interface.
 */
export function instanceOfStageWithGroups(value: object): value is StageWithGroups {
    return true;
}

export function StageWithGroupsFromJSON(json: any): StageWithGroups {
    return StageWithGroupsFromJSONTyped(json, false);
}

export function StageWithGroupsFromJSONTyped(json: any, ignoreDiscriminator: boolean): StageWithGroups {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'stageType': json['stageType'] == null ? undefined : StageTypeFromJSON(json['stageType']),
        'orderIndex': json['orderIndex'] == null ? undefined : json['orderIndex'],
        'bracket': json['bracket'] == null ? undefined : json['bracket'],
        'groups': json['groups'] == null ? undefined : ((json['groups'] as Array<any>).map(GroupWithTeamsFromJSON)),
    };
}

export function StageWithGroupsToJSON(json: any): StageWithGroups {
    return StageWithGroupsToJSONTyped(json, false);
}

export function StageWithGroupsToJSONTyped(value?: StageWithGroups | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'stageType': StageTypeToJSON(value['stageType']),
        'orderIndex': value['orderIndex'],
        'bracket': value['bracket'],
        'groups': value['groups'] == null ? undefined : ((value['groups'] as Array<any>).map(GroupWithTeamsToJSON)),
    };
}

